import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BannerLayer from "../components/BannerLayer";





const BannerManagement = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Banner Management" />

        {/* KanbanLayer */}
        <BannerLayer />

      </MasterLayout>

    </>
  );
};

export default BannerManagement; 
